import type { DeliveryMode } from '@/services/shippingService';
import { NOVAPOST_PRESENCE_COUNTRY_CODES } from '@tulasihome/shared';

const NOVAPOST_PRESENCE_COUNTRIES = new Set(NOVAPOST_PRESENCE_COUNTRY_CODES);

const normalizeCountryCode = (countryCode?: string | null): string => countryCode?.trim().toUpperCase() ?? '';

export const hasNovapostPresence = (countryCode?: string | null): boolean =>
  NOVAPOST_PRESENCE_COUNTRIES.has(normalizeCountryCode(countryCode));

export const getDefaultNovapostDeliveryMode = (countryCode?: string | null): DeliveryMode =>
  hasNovapostPresence(countryCode) ? 'BRANCH' : 'COURIER';
